import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async'; // ← AÑADIR
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider> {/* ← AÑADIR */}
      <App />
    </HelmetProvider> {/* ← AÑADIR */}
  </React.StrictMode>
);

// Registrar Service Worker SOLO en PWA (no en apps nativas)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const isNative = window.Capacitor?.isNativePlatform?.() || false;
    if (isNative) {
      console.log('📱 App Nativa: Service Worker deshabilitado');
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
          registration.unregister();
          console.log('🗑️ Service Worker desregistrado:', registration.scope);
        });
      });
      return;
    }
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('✅ PWA: Service Worker registrado exitosamente:', registration.scope);
      })
      .catch((error) => {
        console.log('❌ PWA: Error registrando Service Worker:', error);
      });
  });
}

reportWebVitals();